/** Compact choices dispatch the same select change as the right inspector. */
export function installLineStyleChoices(popup: HTMLElement, close: () => void) {
  const source = popup.querySelector<HTMLSelectElement>("select")!;
  source.parentElement!.classList.add("native-choice-source");
  const list = document.createElement("div");
  list.className = "native-line-style-choices";
  for (const [value, label] of [
    ["solid", "Сплошная"],
    ["dashed", "Пунктир"],
    ["dotted", "Точки"],
    ["hand", "Ручной"],
  ]) {
    const button = document.createElement("button");
    button.type = "button";
    button.dataset.nativeLineStyle = value;
    const sample = document.createElement("span");
    sample.className = "native-line-sample";
    if (value === "hand") {
      sample.classList.add("native-line-sample-hand");
      sample.innerHTML =
        '<svg viewBox="0 0 40 12" aria-hidden="true"><path d="M1 6 Q5 4 10 6 T20 6 T30 5 T39 6" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"/></svg>';
    } else sample.style.borderTopStyle = value!;
    sample.setAttribute("aria-hidden", "true");
    button.append(sample, document.createTextNode(label!));
    button.onclick = () => {
      source.value = value!;
      source.dispatchEvent(new Event("change", { bubbles: true }));
      close();
    };
    list.append(button);
  }
  popup.append(list);
}
